export default __webpack_public_path__ + "static/media/Pupster3.5906ca66.png";